import React from 'react';
import Modal, { ModalProps } from '@common/modal';
import style from './modeModal.module.scss';
import classnames from 'classnames/bind';
import CloseButton from '@common/closeButton';
import { ContentRouteUtil } from '@utils/routeUtil';
import { useDeleteInterviewPractice } from '@repository/interviewPractices/useInterviewPractices';
import { ContinueInterviewPracticeVO } from '@domain/vo/pass/interview/practice/ContinueInterviewPracticeVO';
import Button from '@components/common/button';

const cx = classnames.bind(style);

interface ModeModalProps extends ModalProps {
  onClose(): void;
  progressInfo?: ContinueInterviewPracticeVO;
}

const InterviewPracticeModeModal = ({ visible, onClose, progressInfo }: ModeModalProps) => {
  const { mutateAsync: deleteInterviewPractice } = useDeleteInterviewPractice();

  //면접 새로 하기 클릭 이벤트
  const onNewClick = async () => {
    if (progressInfo) {
      await deleteInterviewPractice(progressInfo.interviewPracticeSn);
    }

    ContentRouteUtil.goInterviewStart();
  };

  //면접 이어서 하기 클릭 이벤트
  const onContinueClick = async () => {
    if (progressInfo) {
      ContentRouteUtil.openInterviewPracticepage(progressInfo.interviewPracticeSn);
    }
    onClose();
  };

  return (
    <Modal visible={visible} onClickBg={onClose}>
      <div className={cx('layerModeModal')}>
        <div className={cx('textWrap')}>
          <div className={cx('title')}>연습 방법을 선택해 주세요.</div>
          <div className={cx('underline')} />
          <div className={cx('descWrap')}>
            <div className={cx('subtextWrap')}>
              <div className={cx('subtitle')}>이어서 연습하기</div>
              <div className={cx('desc')}>연습 중 이탈한 부분부터 재시작합니다.</div>
            </div>
            <div className={cx('subtextWrap')}>
              <div className={cx('subtitle')}>처음부터 연습하기</div>
              <div className={cx('desc')}>새롭게 연습을 시작합니다.</div>
            </div>
          </div>
        </div>
        <div className={cx('btnWrap')}>
          <Button theme="secondary" className={cx('btn')} onClick={onContinueClick}>
            이어서 연습하기
          </Button>
          <Button className={cx('btn')} onClick={onNewClick}>
            새로 연습하기
          </Button>
        </div>
        <CloseButton className={cx('btnClose')} onClick={onClose} />
      </div>
    </Modal>
  );
};

export default InterviewPracticeModeModal;
